<template>
  <div class="modal modal-project-planner-filters fade fixed-end" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">
            Filter
          </h2>
          <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
        </div>
        <!-- /.drawer-heading -->

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Client</label>
            <multiselect
              :show-labels="false"
              v-model="selectedClient"
              :options="clients"
              label="display_name"
              track-by="id"
              placeholder="Select Client"
              data-vv-name="client"
            ></multiselect>
          </div>

          <div class="mb-3">
            <div class="form-check">
              <input v-model="stateStage1" id="checkbox-show-stage-1" class="form-check-input" type="checkbox" />
              <label for="checkbox-show-stage-1" class="form-check-label">Stage 1</label>
            </div>
          </div>
          <!-- /.form-group-material -->

          <div class="mb-3">
            <div class="form-check">
              <input v-model="stateStage2" id="checkbox-show-stage-2" class="form-check-input" type="checkbox" />
              <label for="checkbox-show-stage-2" class="form-check-label">Stage 2</label>
            </div>
          </div>
          <!-- /.form-group-material -->

          <div class="mb-3">
            <div class="form-check">
              <input v-model="stateStage3" id="checkbox-show-stage-3" class="form-check-input" type="checkbox" />
              <label for="checkbox-show-stage-3" class="form-check-label">Stage 3</label>
            </div>
          </div>
          <!-- /.form-group-material -->

          <div class="mb-3">
            <div class="form-check">
              <input v-model="stateShowUnconfirmed" id="checkbox-show-unconfirmed" class="form-check-input" type="checkbox" />
              <label for="checkbox-show-unconfirmed" class="form-check-label">Unconfirmed</label>
            </div>
          </div>
          <!-- /.form-group-material -->
        </div>
        <!-- /.drawer-body -->
      </div>
      <!-- /.drawer-contents -->
    </div>
  </div>
  <!-- /.drawer -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { stateMapper } from 'mixins/project-planner'
import { CModal } from '@chameleon/chameleon-vue'

export default {
  extends: CModal,
  mixins: [stateMapper],

  computed: {
    ...mapState("clientsList", ["clients"]),

    selectedClient: {
      get() {
        return this.clients.find(item => item.id === this.stateClientId)
      },

      set(value) {
        this.stateClientId = value ? value.id : null
      },
    },
  },

  methods: {

  },
}
</script>

<style>
</style>
